<template>
  <div id="contenedor-actualizar-comentarios-direccion">
    <v-form
      v-model="formularioValido"
      ref="actualizarComentariosDireccion">
      <v-card
        width="100%">
        <v-card-title
          class="secondary--text">
          Comentarios Dirección
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <custom-text-area
            v-model="comentariosDireccion"
            placeholder="comentarios de la dirección..."
            cols="12"
            rows="7">
          </custom-text-area>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="actualizarComentarisDireccion"
            :disabled="!formularioValido || enviandoFormulario"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import CustomTextArea from '@/components/inputs/TextArea.vue';
import CustomButton from '@/components/buttons/Button.vue';
import mixReportesFisicos from './mixReportesFisicos';

export default {
  name: 'ActualizarComentariosDireccion',
  components: {
    CustomTextArea,
    CustomButton,
  },
  props: {
    reporte: {
      type: Object,
      required: true,
    },
  },
  mixins: [mixReportesFisicos],
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      comentariosDireccion: this.reporte.comentariosDireccion,
    };
  },
  methods: {
    limpiarFormulario() {
      this.$refs.actualizarComentariosDireccion.reset();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
  },
};
</script>

<style lang="scss">

</style>
